import React, { Component } from 'react';
import BaseLayout from './../../templates/base'
import ContentFormVersions from './../../elements/versions/form';
import Loading from "../../elements/loading";
import VersionsAdd from './../../elements/versions/widget/versions_add';

class VersionsForm extends Component {
	render() {
		const { versions, groupsPhases } = this.props;
		return (
			(groupsPhases.isFetching || versions.isFetching ) ? <Loading/> : <ContentFormVersions {...this.props}/>
		)
	}

	componentWillMount() {
		this.props.fetchGroupsPhasesList();
		this.props.fetchVersion(this.props.match.params.year);
	}
}

export default BaseLayout(VersionsForm, {
	title:`Editar Versión`,
	subnav: {
		icon: 'fa fa-calendar-check-o',
		name: 'Administración',
		actions: [
			{
				type: 'element',
				url: null,
				name: 'Agregar',
				element: <VersionsAdd />
			}
		]
	}
});


// WEBPACK FOOTER //
// ./src/layouts/versions/edit.jsx